import { NgModule } from '@angular/core';
import { SharedModule } from "../shared/shared.module";
import { EntityService } from 'app/rest/entity.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TempExportComponentsModule } from '../temp-export-components/temp-export-components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';

//#region DRIVERS COMPONENTS
import { DriverInfoCardComponent } from './components/drivers/driver/driver-info-card/driver-info-card.component';
import { DriversTableComponent } from './components/drivers/drivers-table/drivers-table.component';
import { DriversComponent } from './components/drivers/drivers.component';
//#endregion DRIVERS COMPONENTS

//#region VEHICLES COMPONENTS
import { InventoryVehiclesComponent } from './components/vehicle/inventory-vehicles.component';
import { InventoryVehiclesTableComponent } from './components/vehicle/inventory-vehicles-table/inventory-vehicles-table.component';
// import { DocFormComponent } from './components/documents/doc-form/doc-form.component';
// import { DocTableComponent } from './components/documents/doc-table/doc-table.component';
import { InventoryHtcVehicleComponent } from './components/vehicle/inventory-htc-vehicle/inventory-htc-vehicle.component';
//#endregion VEHICLES COMPONENTS

// #region TABLE MANAGEMENT COMPONENTS
import { BrandFormComponent } from './components/table-management/brands/brands-form/brand-form.component';
import { BrandListComponent } from './components/table-management/brands/brands-list/brand-list.component';
import { CompanyFormComponent } from './components/table-management/companies/company-form/company-form.component';
import { CompanyListComponent } from './components/table-management/companies/company-list/company-list.component';
import { CostCentreFormComponent } from './components/table-management/cost-centres/cost-centre-form/cost-centre-form.component';
import { CostCentreListComponent } from './components/table-management/cost-centres/cost-centre-list/cost-centre-list.component';
import { DelegationFormComponent } from './components/table-management/delegations/delegation-form/delegation-form.component';
import { DelegationListComponent } from './components/table-management/delegations/delegation-list/delegation-list.component';
import { ProviderFormComponent } from './components/table-management/providers-management/providers-form/provider-form.component';
import { ProvidersComponent } from './components/table-management/providers-management/providers-list/providers.component';
import { SubdelegationFormComponent } from './components/table-management/subdelegations/subdelegation-form/subdelegation-form.component';
import { SubdelegationListComponent } from './components/table-management/subdelegations/subdelegation-list/subdelegation-list.component';
import { VehicleUsageFormComponent } from './components/table-management/vehicle-usage-management/vehicle-usage-form/vehicle-usage-form.component';
import { VehicleUsageListComponent } from './components/table-management/vehicle-usage-management/vehicle-usage-list/vehicle-usage-list.component';
import { TableManagementComponent } from './components/table-management/table-management.component';

import { CardTypesListComponent } from './components/table-management/cardTypes/cardTypesList/cardTypes-list.component';
import { CardTypeFormComponent } from './components/table-management/cardTypes/cardTypeForm/cardType-form.component';
import { AccessoryListComponent } from './components/table-management/acessories/accessory-list/accessory-list.component';
import { AccessoryFormComponent } from './components/table-management/acessories/accessory-form/accessory-form.component';
import { WayToPayFormComponent } from './components/table-management/way-to-pay/way-to-pay-form/way-to-pay-form.component';
import { WayToPayListComponent } from './components/table-management/way-to-pay/way-to-pay-list/way-to-pay-list.component';
import { FinanceTypesListComponent } from './components/table-management/financing-types/finance-types-list/finance-types-list.component';
import { FinanceTypesFormComponent } from './components/table-management/financing-types/finance-types-form/finance-types-form.component';
import { DocNoteComponent } from './components/documents/doc-note/doc-note.component';
import { DocDriverLicenseComponent } from './components/documents/doc-driver-license/doc-driver-license.component';
import { DocDriverPointsComponent } from './components/documents/doc-driver-points/doc-driver-points.component';
import { VehicleStatusComponent } from './components/table-management/vehicle-status/vehicle-status/vehicle-status.component';
import { VehicleStatusListComponent } from './components/table-management/vehicle-status/vehicle-status-list/vehicle-status-list.component';
import { SubdivisionsListComponent } from './components/table-management/subdivisions/subdivisions-list/subdivisions-list.component';
import { InsuranceTypeListComponent } from './components/table-management/InsuranceTypes/InsuranceType-list/InsuranceType-list.component';
import { InsuranceTypeFormComponent } from './components/table-management/InsuranceTypes/InsuranceType-form/InsuranceType-form.component'// #endregion TABLE MANAGEMENT COMPONENTS
import { DivisionsListComponent } from './components/table-management/divisions/divisions-list/divisions-list.component';
import { DivisionsFormComponent } from './components/table-management/divisions/divisions-form/divisions-form.component';
import { SubdivisionsFormComponent } from './components/table-management/subdivisions/subdivisions-form/subdivisions-form.component';
import { VehicleVersionFormComponent } from './components/table-management/vehicle-version/vehicle-version-form/vehicle-version-form.component';
import { VehicleVersionListComponent } from './components/table-management/vehicle-version/vehicle-version-list/vehicle-version-list.component';
import { VehicleCategoryFormComponent } from './components/table-management/vehicle-category/vehicle-category-form/vehicle-category-form.component';
import { VehicleCategoryListComponent } from './components/table-management/vehicle-category/vehicle-category-list/vehicle-category-list.component';
import { InventoryVehicleFormComponent } from './components/vehicle/inventory-vehicle-form/inventory-vehicle-form.component';
import { FinancingListComponent } from './components/table-management/financing/financing-list/financing-list.component';
import { FinancingFormComponent } from './components/table-management/financing/financing-form/financing-form.component';
import { UploadFileFormComponent } from './components/documents/upload-file-form/upload-file-form.component';
import { UploadDocumentsFormComponent } from './components/documents/upload-documents-form/upload-documents-form.component';
import { CardListsComponent } from './components/table-management/card-lists/card-lists/card-lists.component';
import { CardFormComponent } from './components/table-management/card-lists/card-form/card-form.component';
import { FineListComponent } from './components/table-management/fines/fine-list/fine-list.component';
import { FineFormComponent } from './components/table-management/fines/fine-form/fine-form.component';
import { FineStatusComponent } from './components/table-management/fineStatus/fineStatus-form/fineStatus-form.component';
import { FineStatusListComponent } from './components/table-management/fineStatus/fineStatus-list/fineStatus-list.component';
import { CardConsumptionListComponent } from './components/table-management/cardConsumptions/cardConsumptions-list/cardConsumption-list.component';
import { CardConsumptionFormComponent } from './components/table-management/cardConsumptions/cardConsumption-form/cardConsumption-form.component';
import { RentingTypeListComponent } from './components/table-management/rentingType/list/rentingType-list.component';
import { RentingTypeFormComponent } from './components/table-management/rentingType/form/rentingType-form.component';
import { Rest } from 'app/rest/rest_client';
import { InsuranceListComponent } from './components/table-management/insurance/insurance-list/insurance-list.component';
import { InsuranceFormComponent } from './components/table-management/insurance/insurance-form/insurance-form.component';
import { InventoryVehicleAccessoryListComponent } from './components/vehicle/inventory-vehicle-accessory-list/inventory-vehicle-accessory-list.component';
import { InventoryVehicleAccessoryFormComponent } from './components/vehicle/inventory-vehicle-accessory-form/inventory-vehicle-accessory-form.component';
import { TaxListComponent } from './components/table-management/taxes/taxes-list/taxes-list.component';
import { TaxFormComponent } from './components/table-management/taxes/taxes-form/taxes-form.component';
import { DriversSelectListComponent } from './components/drivers/drivers-select-list/drivers-select-list.component';
import { FineReasonsListComponent } from './components/table-management/fineReasons/fine-reasons-list/fine-reasons-list.component';
import { FineReasonsFormComponent } from './components/table-management/fineReasons/fine-reasons-form/fine-reasons-form.component';
import { SanctionReasonListComponent } from './components/table-management/sanctionReason/sanction-reason-list/sanction-reason-list.component';
import { SanctionReasonFormComponent } from './components/table-management/sanctionReason/sanction-reason-form/sanction-reason-form.component';
import { VehicleListComponent } from './components/vehicle/vehicle/vehicle-list/vehicle-list.component';
import { VehicleFormComponent } from './components/vehicle/vehicle/vehicle-form/vehicle-form.component';
import { DriversAssignmentsListComponent } from './components/drivers/drivers-assignments-list/drivers-assignments-list.component';
import { VehicleAssignmentsListComponent } from './components/vehicle/vehicle-assignments-list/vehicle-assignments-list.component';
import { PendingVehicleAssignmentsListComponent } from './components/vehicle/pending-vehicle-assignments-list/pending-vehicle-assignments-list.component';
import { PendingDriverAssignmentsListComponent } from './components/vehicle/pending-driver-assignments-list/pending-driver-assignments-list.component';
import { PendingVehicleAssignmentsFormComponent } from './components/vehicle/pending-vehicle-assignments-form/pending-vehicle-assignments-form.component';
import { PendingDriverAssignmentsFormComponent } from './components/vehicle/pending-driver-assignments-form/pending-driver-assignments-form.component';
import { InsuranceComponentListComponent } from './components/table-management/insurance/insurance-component-list/insurance-component-list.component';
import { InsuranceQuarterlyCalculationComponent } from './components/table-management/insurance/insurance-quarterly-calculation/insurance-quarterly-calculation.component';
// #endregion TABLE MANAGEMENT COMPONENTS

//#region REPORTS COMPONENTS
import { ReportsWizardComponent } from './components/reports-wizard/reports-wizard.component';
import { ReportsHeaderComponent } from './components/reports-wizard/reports-header/reports-header.component';
import { ReportsBodyComponent } from './components/reports-wizard/reports-body/reports-body.component';
import { LicenseReportFormComponent } from './components/reports-wizard/license-report-form/license-report-form.component';
import { ReportGeneratorComponent } from './components/reports-wizard/report-generator/report-generator.component';
import { ReportBuilderComponent } from './components/reports-wizard/report-builder/report-builder.component';
import { LeaderListComponent } from './components/table-management/leaders/leader-list/leader-list.component';
import { LeaderFormComponent } from './components/table-management/leaders/leader-form/leader-form.component';
//#endregion REPORTS COMPONENTS
import { ReportComponent } from './components/table-management/insurance/report/report.component';
import { InsuranceReportFormComponent } from './components/reports-wizard/insurance-report-form/insurance-report-form.component';
import { VehicleAccesoryReportFormComponent } from './components/reports-wizard/vehicle-accesory-report-form/vehicle-accesory-report-form.component';
import { FinesReportFormComponent } from './components/reports-wizard/fines-report-form/fines-report-form.component';
import { VehicleConsumptionReportFormComponent } from './components/reports-wizard/vehicle-consumption-report-form/vehicle-consumption-report-form.component';
import { CardsReportFormComponent } from './components/reports-wizard/cards-report-form/cards-report-form.component';
import { ItvExpirationReportFormComponent } from './components/reports-wizard/itv-expiration-report-form/itv-expiration-report-form.component';
import { VehicleExpirationReportFormComponent } from './components/reports-wizard/vehicle-expiration-report-form/vehicle-expiration-report-form.component';
import { VehicleReportFormComponent } from './components/reports-wizard/vehicle-report-form/vehicle-report-form.component';
import { RealStateListComponent } from './components/table-management/real-state/real-state-list/real-state-list.component';
import { RealStateFormComponent } from './components/table-management/real-state/real-state-form/real-state-form.component';
import { HtcCardListComponent } from './components/table-management/card-lists/htc-card-list/htc-card-list.component';
import { HtcVehicleStatusListComponent } from './components/table-management/vehicle-status/htc-vehicle-status-list/htc-vehicle-status-list.component';
import { HtcVehicleUsageListComponent } from './components/table-management/vehicle-usage-management/htc-vehicle-usage-list/htc-vehicle-usage-list.component';
import { FocusOnNextEnterDirective } from './focus-on-next-enter.directive';
import { FilterColumnsAutoFocusDirective } from './filter-columns-auto-focus.directive';
import { ModelFormComponent } from './components/table-management/models/model-form/model-form.component';
import { ModelListComponent } from './components/table-management/models/model-list/model-list.component';
import { MileageFormComponent } from './components/vehicle/inventory-vehicle-mileage/mileage-form/mileage-form.component';
import { MileageListComponent } from './components/vehicle/inventory-vehicle-mileage/mileage-list/mileage-list.component';
import { MileageStatsComponent } from './components/vehicle/inventory-vehicle-mileage/mileage-stats/mileage-stats.component';
import { CardConsumptionSummaryComponent } from './components/table-management/cardConsumptions/card-consumption-summary/card-consumption-summary.component';
import { NotesListComponent } from './components/table-management/notes-list/notes-list.component';
import { NotesFormComponent } from './components/table-management/notes-form/notes-form.component';
import { RenewalFilesComponent } from './components/documents/renewal-files/renewal-files.component';
import { EmployeeListComponent } from './components/table-management/employee/employee-list/employee-list.component';
import { EmployeeFormComponent } from './components/table-management/employee/employee-form/employee-form.component';
import { DriversAssignmentsFormComponent } from './components/drivers/drivers-assignments-form/drivers-assignments-form.component';
import { VehicleAssignmentsFormComponent } from './components/vehicle/vehicle-assignments-form/vehicle-assignments-form.component';
import { NiifReportFormComponent } from './components/reports-wizard/niif-report-form/niif-report-form.component';
import { DriverAssignmentsReportFormComponent } from './components/reports-wizard/driver-assignments-report-form/driver-assignments-report-form.component';
import { InsuranceCompFormComponent } from './components/table-management/insurance/insurance-comp-form/insurance-comp-form.component';
import { CecoReportFormComponent } from './components/reports-wizard/ceco-report-form/ceco-report-form.component';
import { SinisterTypeFormComponent } from './components/table-management/sinister/sinisterType/sinister-type-form/sinister-type-form.component';
import { SinisterTypeListComponent } from './components/table-management/sinister/sinisterType/sinister-type-list/sinister-type-list.component';
import { WorkshopFormComponent } from './components/table-management/sinister/workshop/workshop-form/workshop-form.component';
import { WorkshopListComponent } from './components/table-management/sinister/workshop/workshop-list/workshop-list.component';
import { SinisterListComponent } from './components/table-management/sinister/sinister-list/sinister-list.component';
import { SinisterFormComponent } from './components/table-management/sinister/sinister-form/sinister-form.component';
import { SanctionListComponent } from './components/table-management/sanction/sanction-list/sanction-list.component';
import { SanctionFormComponent } from './components/table-management/sanction/sanction-form/sanction-form.component';
import { ObservationsListComponent } from './components/table-management/observations/observations-list/observations-list.component';
import { ObservationsFormComponent } from './components/table-management/observations/observations-form/observations-form.component';
import { SinisterReportFormComponent } from './components/reports-wizard/sinister-report-form/sinister-report-form.component';
import { SanctionReportFormComponent } from './components/reports-wizard/sanction-report-form/sanction-report-form.component';
import { BreakdownReasonFormComponent } from './components/table-management/breakdown/breakdown-reason/breakdown-reason-form/breakdown-reason-form.component';
import { BreakdownReasonListComponent } from './components/table-management/breakdown/breakdown-reason/breakdown-reason-list/breakdown-reason-list.component';
import { BreakdownFollowingFormComponent } from './components/table-management/breakdown/breakdown-following/breakdown-following-form/breakdown-following-form.component';
import { BreakdownFollowingListComponent } from './components/table-management/breakdown/breakdown-following/breakdown-following-list/breakdown-following-list.component';
import { BreakdownFormComponent } from './components/table-management/breakdown/breakdown-form/breakdown-form.component';
import { BreakdownListComponent } from './components/table-management/breakdown/breakdown-list/breakdown-list.component';
import { BreakdownReportFormComponent } from './components/reports-wizard/breakdown-report-form/breakdown-report-form.component';
import { SyncProcessLogsComponent } from './components/table-management/cardConsumptions/sync-process-logs/sync-process-logs.component';
import { SyncProcessLogsErrorComponent } from './components/table-management/cardConsumptions/sync-process-logs-error/sync-process-logs-error.component';
@NgModule({
    declarations: [
        //#region DRIVERS COMPONENTS
        DriversComponent,
        DriverInfoCardComponent,
        DriversTableComponent,
        //#endregion DRIVERS COMPONENTS

        //#region VEHICLES COMPONENTS
        InventoryVehiclesComponent,
        InventoryVehiclesTableComponent,
        InventoryVehicleFormComponent,
      //   DocFormComponent,
      //   DocTableComponent,
        UploadFileFormComponent,

        //#endregion VEHICLES COMPONENTS

        //#region HTC VEHICLES COMPONENTS
        //VehicleStatusListHtcComponent,
        //#endregion HTC VEHICLES COMPONENTS

        //#region TABLE MANAGEMENT COMPONENTS
        BrandFormComponent,
        BrandListComponent,
        ModelListComponent,
        ModelFormComponent,
        CompanyFormComponent,
        CompanyListComponent,
        CostCentreFormComponent,
        CostCentreListComponent,
        LeaderListComponent,
        LeaderFormComponent,
        DelegationFormComponent,
        DelegationListComponent,
        ProviderFormComponent,
        ProvidersComponent,
        SubdelegationFormComponent,
        SubdelegationListComponent,
        VehicleUsageFormComponent,
        VehicleUsageListComponent,
        CardTypesListComponent,
        CardTypeFormComponent,
        AccessoryListComponent,
        AccessoryFormComponent,
        WayToPayFormComponent,
        WayToPayListComponent,
        FinanceTypesListComponent,
        FinanceTypesFormComponent,
        //DocNoteComponent,
        DocDriverLicenseComponent,
        //DocDriverPointsComponent,
        VehicleStatusComponent,
        VehicleStatusListComponent,
        DivisionsListComponent,
        DivisionsFormComponent,
        SubdivisionsFormComponent,
        SubdivisionsListComponent,
        InsuranceTypeListComponent,
        InsuranceTypeFormComponent,
        VehicleVersionFormComponent,
        VehicleVersionListComponent,
        VehicleCategoryFormComponent,
        VehicleCategoryListComponent,
        CardListsComponent,
        CardFormComponent,
        FineListComponent,
        FineFormComponent,
        FineStatusComponent,
        FineStatusListComponent,
        CardConsumptionListComponent,
        CardConsumptionFormComponent,
        RentingTypeListComponent,
        RentingTypeFormComponent,
        FinancingFormComponent,
        FinancingListComponent,
        InsuranceListComponent,
        InsuranceFormComponent,
        InventoryHtcVehicleComponent,
        InventoryVehicleAccessoryListComponent,
        InventoryVehicleAccessoryFormComponent,
        TaxListComponent,
        TaxFormComponent,
        DriversSelectListComponent,
        InventoryHtcVehicleComponent,
        InventoryVehicleAccessoryListComponent,
        InventoryVehicleAccessoryFormComponent,
        FineReasonsListComponent,
        FineReasonsFormComponent,
        SanctionReasonListComponent,
        SanctionReasonFormComponent,
        VehicleListComponent,
        VehicleFormComponent,
        DriversAssignmentsListComponent,
        VehicleAssignmentsListComponent,
        PendingVehicleAssignmentsListComponent,
        PendingDriverAssignmentsListComponent,
        PendingVehicleAssignmentsFormComponent,
        PendingDriverAssignmentsFormComponent,
        InsuranceComponentListComponent,
        InsuranceQuarterlyCalculationComponent,
        ReportComponent,
        //#endregion TABLE MANAGEMENT COMPONENTS

        //#region REPORTS COMPONENTS
        ReportsWizardComponent,
        ReportsHeaderComponent,
        ReportsBodyComponent,
        LicenseReportFormComponent,
        ReportGeneratorComponent,
        ReportBuilderComponent,
        InsuranceReportFormComponent,
        VehicleAccesoryReportFormComponent,
        FinesReportFormComponent,
        VehicleConsumptionReportFormComponent,
        CardsReportFormComponent,
        ItvExpirationReportFormComponent,
        VehicleExpirationReportFormComponent,
        VehicleReportFormComponent,
        RealStateListComponent,
        RealStateFormComponent,
        HtcCardListComponent,
        HtcVehicleStatusListComponent,
        HtcVehicleUsageListComponent,
        FocusOnNextEnterDirective,
        FilterColumnsAutoFocusDirective,
        MileageFormComponent,
        MileageListComponent,
        MileageStatsComponent,
        CardConsumptionSummaryComponent,
        NotesListComponent,
        NotesFormComponent,
        UploadDocumentsFormComponent,
        RenewalFilesComponent,
        EmployeeListComponent,
        EmployeeFormComponent,
        DriversAssignmentsFormComponent,
        VehicleAssignmentsFormComponent,
        NiifReportFormComponent,
        DriverAssignmentsReportFormComponent,
        InsuranceCompFormComponent,
        CecoReportFormComponent,
        SinisterTypeFormComponent,
        SinisterTypeListComponent,
        WorkshopFormComponent,
        WorkshopListComponent,
        SinisterListComponent,
        SinisterFormComponent,
        SanctionListComponent,
        SanctionFormComponent,
        ObservationsFormComponent,
        ObservationsListComponent,
        SinisterReportFormComponent,
        SanctionReportFormComponent,
        BreakdownReasonFormComponent,
        BreakdownReasonListComponent,
        BreakdownFollowingFormComponent,
        BreakdownFollowingListComponent,
        BreakdownFormComponent,
        BreakdownListComponent,
        BreakdownReportFormComponent,
        SyncProcessLogsComponent,
        SyncProcessLogsErrorComponent
        //#endregion REPORTS COMPONENTS
    ],
    imports: [
        SharedModule,
        TempExportComponentsModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        MultiSelectModule

    ],
    exports: [
        BrandFormComponent,
        ModelFormComponent,
        VehicleVersionFormComponent,
        BrandListComponent,
        ModelListComponent,
        VehicleVersionListComponent,
        VehicleCategoryFormComponent,
        VehicleCategoryListComponent
       ]
})
//export class VehicleInventoryModule extends EntityService<Rest.Vehicle>{
export class VehicleInventoryModule  {}
